import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import SubmitButtonComponent from 'webapp/components/submit-button';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/view-digest';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeViewDigestComponent extends Component<Args> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('model-manager/metric-digests')
	declare mmMetricDigestsService: Service.ModelManager.MetricDigests;

	@action
	openEdit(): void {
		this.mmMetricDigestsService.edit(this.args.model.metricDigest!, 'notifications');
	}
	<template>
		<div
			class="infolayer infolayer--type-view-digest infolayer--type-view-digest--{{@model.digestActiveStatusString}}
				{{@model.classes}}"
		>
			<div>
				{{#if @model.isLoading}}
					<p>{{@model.statusString}}ing weekly update...</p>
				{{else}}
					{{#if @model.isDisabling}}
						<p>{{@model.statusText}}</p>
					{{else}}
						<h3>{{@model.statusText}}</h3>
						<p>Click on the button below to edit your scheduled Metric digest.</p>
					{{/if}}
					<div class="controls2">
						<div class="controls2__right">
							<a class="close" {{on "click" @onClose}}>Dismiss</a>

							{{#unless @model.isDisabling}}
								<SubmitButtonComponent
									@text="Edit"
									@noDelay={{true}}
									@theme="white-outlined-blue"
									@onTrigger={{this.openEdit}}
								/>
							{{/unless}}
						</div>
					</div>
				{{/if}}
			</div>
		</div>
	</template>
}
